































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
  tasks = [
    {
      name: 'Nhập liệu',
      icon: 'mdi-folder-multiple-plus-outline',
      routeName: 'NhapLieu',
    },
    {
      name: 'Giám sát tài chính',
      icon: 'mdi-currency-usd',
      routeName: 'GiamSatTaiChinh',
    },
    {
      name: 'Đánh giá người đại diện',
      icon: 'mdi-account-check-outline',
      routeName: 'DanhGiaNDD',
    },
    {
      name: 'Tổng hợp DT, LN, TL, CT',
      icon: 'mdi-chart-box-outline',
      routeName: 'TongHopDtLnTlCt',
    },
  ]
}
